import { createAsyncThunk } from '@reduxjs/toolkit'
import { SCREEN } from '../../../../../../common/selectCurrencyUnit/constant'
import { calculateDefaultUnit } from '../../../../../../common/selectCurrencyUnit/slice'
import { handleExport } from '../../../../../../helpers/export'
import FinancialAnalysisService from '../../../core/service'
import { mapAllVNDValue } from '../../../helper'

export const getSecuOperatingIncomeThunk = createAsyncThunk(
  'financialAnalysis/Secu/GET_OPERATING_INCOME',
  async (data, { rejectWithValue, dispatch }) => {
    const response = await FinancialAnalysisService.getOperatingIncome(data)
    if (response.success) {
      dispatch(
        calculateDefaultUnit({
          screen: SCREEN.FINANCIAL_ANALYSIS,
          getValues: () => mapAllVNDValue(response.data),
        }),
      )
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const downloadSecuOperatingIncome = createAsyncThunk(
  'financialAnalysis/Secu/DOWNLOAD_OPERATING_INCOME',
  async (data) => {
    const response = await FinancialAnalysisService.downloadOperatingIncome(
      data,
    )
    handleExport(response.data, response.filename)
  },
)
